module.exports = "<i class=\"fa {{ $ctrl.batteryIcon }}\" aria-hidden=true></i> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/battery-status/battery-status.html
// module id = P3sd
// module chunks = 1